<template>
  <div class="pdf-viewer" :style="{height: height + 'px'}" @contextmenu.prevent>
    <div class="bodyArea">
      <el-image v-for="url in urls" :key="url" :src="url" lazy @contextmenu.prevent @dragstart.prevent></el-image>
    </div>
  </div>
</template>

<script>
export default {
  props: ['pdfUrl', 'height'],
  data () {
    return {
      count: null,
      urls: []
    }
  },
  mounted () {
    this.loading = true
    this.$http.post('common/service/getPdfPageCount', { fileUrl: this.pdfUrl }).then((res) => {
      for (let i = 0; i < res.data; i++) {
        this.urls.push(this.$baseURL + '/common/service/previewPdf/' + this.pdfUrl + '__' + i)
      }
    })
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.pdf-viewer {
  width: 100%;
  height: 100%;
  overflow: auto;
  .bodyArea {
    border: 1px solid #acacac88;
  }
}
</style>
